import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Header from '../components/Header';

export const PrivateAdminRoute = ({
  isAuthenticatedAdmin,
  component: Component,
  ...rest
}) => (
    <Route {...rest} component={(props) => (
      isAuthenticatedAdmin ? (
        <div>
          <Component {...props} />
        </div>
      ) : (
          <Redirect to="/" />
        )
    )} />
  );

const mapStateToProps = (state) => ({
  isAuthenticatedAdmin: !!state.auth.token && state.auth.role === 'administrator'
});

export default connect(mapStateToProps)(PrivateAdminRoute);



// WEBPACK FOOTER //
// ./src/routers/PrivateAdminRoute.jsx